module.exports = __webpack_public_path__ + "img/light.497f1fe1.svg";